import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateAccountComponent } from '../create-account/create-account.component';
// import { CreateAccountComponent } from '../create-account/create-account.component';

const routes: Routes = [
  // TODO: figure out how to sensibly "extend" routes as I don't want to have to redeclare all this
  // { path: 'create-account', component: CreateAccountComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ],
  entryComponents: [
    CreateAccountComponent
  ]
})
export class AppRoutingModule { }
